import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-payment-print',
  templateUrl: './payment-print.component.html',
  styleUrls: ['./payment-print.component.css'],
  standalone: false
})
export class PaymentPrintComponent implements OnInit {

  @Input() vm: any;
  @Input() showPaidWatermark = false;

  constructor() { }

  ngOnInit() {
  }

  hasCreditsApplied(applied: any[]): boolean {
    return (applied || []).some((p: any) => (p.applied_amount || 0) < 0);
  }

}
